import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import type { FunnelStage } from '@/models/salesAnalytics'

const pct = (n: number) => `${(n * 100).toFixed(1)}%`

export function FunnelCard({
  stages,
  applicationsWithoutLead,
}: {
  stages: FunnelStage[]
  applicationsWithoutLead: number
}) {
  const top = stages[0]?.leads || 1
  return (
    <Card>
      <CardHeader>
        <CardTitle>Lead funnel</CardTitle>
        <p className="text-sm text-neutral-500">
          Every stage counts the same leads, so a lead that closed still counts as one that was quoted.
        </p>
      </CardHeader>
      <CardContent className="flex flex-col gap-2">
        {stages.map((stage, i) => (
          <div key={stage.label} className="grid grid-cols-[11rem_1fr_auto] items-center gap-3">
            <div className="text-sm text-neutral-500">{stage.label}</div>
            <div className="h-6 overflow-hidden rounded bg-neutral-100 dark:bg-neutral-800">
              <div
                className="h-full rounded bg-indigo-500"
                style={{ width: `${(stage.leads / top) * 100}%` }}
              />
            </div>
            <div className="text-sm whitespace-nowrap tabular-nums">
              {stage.leads}
              {i > 0 ? ` (${pct(stage.conversionFromPrevious)})` : ''}
            </div>
          </div>
        ))}
        {applicationsWithoutLead > 0 && (
          <p className="pt-2 text-sm text-amber-700 dark:text-amber-400">
            {applicationsWithoutLead} application
            {applicationsWithoutLead === 1 ? '' : 's'} in range came from no lead — a self-serve signup, or a
            lead whose org was never linked. The stages below Leads cannot see them, so the quoting pipeline
            is larger than it looks.
          </p>
        )}
      </CardContent>
    </Card>
  )
}
